import { createFileRoute } from '@tanstack/react-router'
import OrderBreakDownScreen from './-components/screen'
import { pharmacyClient } from '@/connect'

import {z} from 'zod'
import { Loading } from '@/layouts/loading'
const Params = z.object({
  supplierId: z.string().default("all"),
  stockPointId: z.string().default("all"),
})
type Params = z.infer<typeof Params>

export const Route = createFileRoute('/(inventory)/branch/_layout/purchase-invoices/$id/')({
  component: OrderBreakDownScreen,
  validateSearch: Params,
  loaderDeps: ({ search: { supplierId, stockPointId } }) => ({
    supplierId,
    stockPointId,
  }),
  loader: async ({params, deps}) => {
    const purchaseInvoiceInfo = await pharmacyClient.getPurchaseInvoice({
      purchaseInvoiceId: params.id,
      supplierId: deps.supplierId !== "all" ? deps.supplierId : "",
      stockPointId: deps.stockPointId !== "all" ? deps.stockPointId : "",
    })
    const activity = await pharmacyClient.purchaseActivity({
      purchaseInvoiceId: params.id,
    })
    return {
      purchaseInvoice: purchaseInvoiceInfo,
      activity: activity,
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})